import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=13f1e06d&scoped=true"
import script from "./UserSelect.vue?vue&type=script&lang=ts"
export * from "./UserSelect.vue?vue&type=script&lang=ts"
import style0 from "./UserSelect.vue?vue&type=style&index=0&id=13f1e06d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f1e06d",
  null
  
)

export default component.exports